import { render, staticRenderFns } from "./selectSaleAddons.vue?vue&type=template&id=c6997854&scoped=true"
import script from "./selectSaleAddons.vue?vue&type=script&lang=js"
export * from "./selectSaleAddons.vue?vue&type=script&lang=js"
import style0 from "./selectSaleAddons.vue?vue&type=style&index=0&id=c6997854&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6997854",
  null
  
)

export default component.exports